import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify';
import router from './router'
import i18n from './i18n'
import VCalendar from 'v-calendar';
import * as Resize from './iframeResizer.contentWindow.min.js'
import * as Sentry from "@sentry/vue"
import Hotjar from 'vue-hotjar'
import packageJson from '../package.json'
import currencyFormatter from "currency-formatter"
import VueGtag from "vue-gtag"

const version = packageJson.version

// eslint-disable-next-line
console.info(`SalesCloud schedule v${version}`);

Vue.config.productionTip = false
Vue.use(Resize)
Vue.use(require('vue-moment'))

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
})

Vue.use(Hotjar, {
  id: process.env.VUE_APP_HOTJAR_ID  // Hotjar Site ID
})

Vue.use(VueGtag, {
  bootstrap: false
})

Vue.filter('formatPrice', (price) => {
  if(typeof price !== 'undefined' && price !== null) {
    let amount = 0
    let currencyCode = 'ISK'
    let decimalDigits = 0

    if(typeof price.amount !== 'undefined' && price.amount !== null) {
      amount = price.amount
    }

    if(typeof price.currency_code !== 'undefined' && price.currency_code !== null) {
      currencyCode = price.currency_code
    }

    if(typeof price.decimals !== 'undefined' && price.decimals !== null) {
      decimalDigits = price.decimals
    } else {
      const foundCurrency = currencyFormatter.findCurrency(currencyCode)
      if(foundCurrency) {
        decimalDigits = foundCurrency.decimalDigits
      }
    }

    if(decimalDigits > 0) {
      amount = amount / Math.pow(10, decimalDigits)
    }

    return currencyFormatter.format(amount, { code: currencyCode })
  }
  return ''
})

Vue.filter('capitaliseFirstLetter', (string) => {
  if(typeof string === 'string' && string.length > 0) {
    return string.substring(0, 1).toUpperCase() + string.substring(1).toLowerCase()
  }
  return ''
})

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration({ router }),],
  environment: process.env.VUE_APP_ENVIRONMENT ?? 'production',
  initialScope: {
    tags: {
      version
    }
  },
  // Tracing
  tracesSampleRate: 0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/schedule\.salescloud\.is/],
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

new Vue({
  store,
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
